import * as React from "react";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
const Wrapper = styled.div`
  border-radius: 6px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }

  div[class^='col-'] {
    padding-right: 0;
    padding-left: 0;
  }

  .form-group {
    margin: 0 0 3px;
  }

  .control-label {
    padding-top: 5px;
    text-align: left;
    hyphens: auto;
  }

  .help-block {
    margin: 0;
    hyphens: auto;
  }

  .checkbox {
    min-height: auto;
  }
`;
const Header = styled.div(
  ({ theme, $isEmpty }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1px;
    min-height: 26px;
    font-weight: bold;
    background-color: ${theme.colors.global.contentBackground};
    position: sticky;
    top: 0;
    z-index: 1;

    &::before {
      content: ' ';
      top: 50%;
      width: 100%;
      border-bottom: 1px solid
        ${$isEmpty ? theme.colors.gray["70"] : theme.utils.contrastingColor(theme.colors.global.contentBackground, "AA")};
      position: absolute;
    }
  `
);
const ElementTitle = styled.div(
  ({ theme, $isEmpty }) => css`
    background-color: ${theme.colors.global.contentBackground};
    color: ${$isEmpty ? theme.colors.gray["70"] : theme.colors.text.primary};
    z-index: 1;
    padding-right: 8px;
  `
);
const ElementActions = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    z-index: 1;
    padding-left: 5px;
  `
);
const StyledIconButton = styled(IconButton)(
  ({ theme }) => `
  color: ${theme.colors.text.primary};
`
);
const ElementConfigurationSection = ({
  allowCreate,
  children,
  elementTitle,
  isEmpty = false,
  onCreate,
  sectionTitle = void 0
}) => {
  const title = sectionTitle != null ? sectionTitle : elementTitle;
  return /* @__PURE__ */ React.createElement(Wrapper, { "data-testid": `${title}-section` }, /* @__PURE__ */ React.createElement(Header, { $isEmpty: isEmpty }, /* @__PURE__ */ React.createElement(ElementTitle, { $isEmpty: isEmpty }, title), /* @__PURE__ */ React.createElement(ElementActions, null, allowCreate && /* @__PURE__ */ React.createElement(StyledIconButton, { title: `Add a ${elementTitle}`, name: "add", onClick: onCreate }))), /* @__PURE__ */ React.createElement("div", null, children));
};
export default ElementConfigurationSection;
